export default __webpack_public_path__ + "media/images/icons/arrow-right-aef03306a9690a94608f71c386703dd7.svg";